import { render, staticRenderFns } from "./RealityUpgradeButton.vue?vue&type=template&id=0f262c38&scoped=true&"
import script from "./RealityUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./RealityUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f262c38",
  null
  
)

export default component.exports